module.exports = __webpack_public_path__ + "static/sf_devices.584075cc.png";